export enum LogCardSubtitleType {
  Details,
  Updated,
  CreatedRelative,
  UpdatedRelative,
  HeadlineStatus,
}
